import axios from 'axios';

export function bulkDownload(fileIds) {
	const bodyFormData = new FormData();
	bodyFormData.append('action', 'employee_comms_multi_download');
	fileIds.forEach((item) => {
		bodyFormData.append('document_ids[]', item);
	});

	// Get WP ajax URL. This wont work on localhost anyway because of CORS
	axios.post(window.tpp_comms_ajax_params.ajax_url, bodyFormData )
	.then(response => {
		// Gives downloads a nice name
		var link = document.createElement('a');
		link.download = 'Communications toolkit download';
		link.href = response.data.zip_file;
		link.click();
	}).catch(error => {
		console.log(error);
	});
}

// This function is an alternative to Object.hasOwn, as that function is not supported
function hasOwn(obj, prop) {
	if (typeof obj !== "object" || ! obj ) {
		return false;
	}

	return prop in obj;
}


// Lazy hardcoded way of getting topic labels, although does cut down on REST call...
export function getTopicLabel(topic) {
	const topicChoices = {
		all: 'All',
		preparing_for_staging: 'Preparing for pension duties',
		introducing_the_peoples_pension: "Introducing The People's Pension",
		account_management: 'Account management',
		combining_pension_pots: 'Combining pension pots',
		understanding_investments: 'Understanding investments',
		growing_savings: 'Growing savings',
		retirement_planning: 'Retirement planning',
		'automatic_re-enrolment': 'Automatic re-enrolment',
		switching_providers: 'Switching pension providers',
		minimum_contribution_increases: 'Minimum contribution increases',
		understanding_our_charges: 'Understanding our charges',
	};

	if ( hasOwn( topicChoices, topic ) ) {
		return topicChoices[topic];
	}
	return topic;
}

export function getTypeLabel(type) {
	const typeChoices = {
		all: 'All',
		booklet: 'Booklets',
		poster: 'Posters',
		flyers: 'Flyers',
		videos: 'Videos',
		presentations: 'Presentations',
		forms: 'Forms',
		letter_and_wording_templates: 'Letter and wording templates',
	};

	if ( hasOwn( typeChoices, type ) ) {
		return typeChoices[type];
	}
	return type;
}

export function getLanguageLabel(type) {
	const languageChoices = {
		bulgarian: 'Bulgarian',
		french: 'French',
		german: 'German',
		hungarian: 'Hungarian',
		italian: 'Italian',
		polish: 'Polish',
		portugese: 'Portuguese',
		romanian: 'Romanian',
		russian: 'Russian',
		spanish: 'Spanish',
	};

	if ( hasOwn( languageChoices, type ) ) {
		return languageChoices[type];
	}
	return type;
}
